module.exports = __webpack_public_path__ + "bf00bc35c700478fac161b70fd7acffe.png";